import React from 'react';
import { toFriendlyDateTimeString, formatPhone } from 'helpers/Formatter';

export function visitorDetails(visitorDetails) {
  const visitingTenantDetails =
    visitorDetails && visitorDetails.unit_number
      ? `${visitorDetails.visiting_tenant} in unit ${visitorDetails.unit_number}`
      : visitorDetails.visiting_tenant;

  const style = {
    info_header: {
      margin: '5px -20px 10px -20px',
      backgroundColor: '#f1f1f1',
      padding: '5px 10px',
      fontSize: '14px',
      fontWeight: '800',
    },
  };

  return (
    <div>
      <div className="row">
        <div className="col-xs-12" style={{ marginBottom: '15px' }}>
          <p>
            Below is the information regarding a building visitor. Make sure to check in and check
            out visitors as they enter and leave to maximize building security.
          </p>
        </div>
      </div>

      <div className="row" style={style.info_header}>
        <div className="col-xs-12">
          <p style={{ margin: '0', textAlign: 'center' }}> VISITOR DETAILS </p>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Visitor Name</h5>
          <p>{visitorDetails.full_name}</p>
        </div>
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Visiting</h5>
          <p>{visitingTenantDetails}</p>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Visitors Phone Number</h5>
          <p>{formatPhone(visitorDetails.phone_number) || 'N/A'}</p>
        </div>
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Visitors Email</h5>
          <p>{visitorDetails.email || 'N/A'}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Expected Arrival</h5>
          <p>
            {visitorDetails.expected_arrival_at
              ? toFriendlyDateTimeString(visitorDetails.expected_arrival_at)
              : 'N/A'}
          </p>
        </div>
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Expected Departure</h5>
          <p>
            {visitorDetails.expected_departure_at
              ? toFriendlyDateTimeString(visitorDetails.expected_departure_at)
              : 'N/A'}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Checked In By</h5>
          <p>{visitorDetails.checked_in_by || 'N/A'}</p>
        </div>
        <div className="col-sm-6">
          <h5 style={{ marginBottom: '2px' }}>Checked Out By</h5>
          <p>{visitorDetails.checked_out_by || 'N/A'}</p>
        </div>
      </div>
      {visitorDetails.notes && (
        <div className="row">
          <div className="col-sm-12">
            <h5 style={{ marginBottom: '2px' }}>Notes</h5>
            <p>{visitorDetails.notes}</p>
          </div>
        </div>
      )}
    </div>
  );
}
